var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "metamask-connector"
  }, [!_vm.isMetaMaskInstalled ? _c('div', {
    staticClass: "metamask-not-installed"
  }, [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle mr-2"
  }), _vm._v(" MetaMask is not installed. Please install MetaMask to continue. "), _c('a', {
    attrs: {
      "href": "https://metamask.io/download.html",
      "target": "_blank"
    }
  }, [_vm._v("Download MetaMask")])])], 1) : _c('div', [!_vm.isConnected ? _c('b-button', {
    staticClass: "metamask-button",
    attrs: {
      "variant": "success",
      "size": "sm",
      "pill": "",
      "disabled": _vm.connecting
    },
    on: {
      "click": _vm.connectMetaMask
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "src": "/metamask.svg",
      "alt": "Metamask icon"
    }
  }), _vm._v(" " + _vm._s(_vm.connecting ? "Connecting..." : "Connect MetaMask") + " ")]) : _c('div', {
    staticClass: "connection-info"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "connected-status"
  }, [_c('span', {
    staticClass: "status-dot"
  }), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Connected")]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "ml-2 p-0",
    staticStyle: {
      "width": "26px",
      "height": "26px",
      "font-size": "12px"
    },
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "pill.": "",
      "title": "Disconnect wallet"
    },
    on: {
      "click": _vm.disconnectMetaMask
    }
  }, [_c('i', {
    staticClass: "fa fa-chain-broken",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _c('div', {
    staticClass: "address-display ml-3"
  }, [_vm._v(" " + _vm._s(_vm.truncatedAddress) + " ")]), _vm.networkName ? _c('div', {
    staticClass: "network-info ml-3"
  }, [_c('b-badge', {
    staticClass: "px-4 w-auto",
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("Network: ")]), _vm._v("    "), _c('strong', [_vm._v(_vm._s(_vm.networkName))])])], 1) : _vm._e()])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }